export enum SmartCoachEvidenceType {
  LINK = 'Link with description',
  PHOTO = 'Photo with description',
  VIDEO = 'Video with description',
  DESCRIPTION = 'Detailed description of implementation only',
}
